import { Box, Typography, Container, Grid, Paper, Avatar, LinearProgress } from '@mui/material';
import { motion } from 'framer-motion';
import { Code, School, Work } from '@mui/icons-material';

const About = () => {
  const experiences = [
    {
      icon: <Work fontSize="large" color="primary" />,
      title: 'Experience',
      description: '3+ years developing web applications',
    },
    {
      icon: <Code fontSize="large" color="primary" />,
      title: 'Projects',
      description: '5+ completed projects',
    },
    {
      icon: <School fontSize="large" color="primary" />,
      title: 'Education',
      description: 'B.Tech Degree in Computer Science',
    },
  ];

  return (
    <Box id="about" sx={{ py: 8, bgcolor: 'background.default' }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h2" component="h2" align="center" sx={{ mb: 6 }}>
            About Me
          </Typography>
          
          <Grid container spacing={6} alignItems="center">
            <Grid item xs={12} md={6}>
              <Box sx={{ 
                display: 'flex', 
                justifyContent: 'center', 
                mb: 4,
                '& img': {
                  width: '250px',
                  height: '250px',
                  borderRadius: '50%',
                  objectFit: 'cover',
                  border: '4px solid #00bcd4',
                  boxShadow: '0 4px 8px rgba(0,0,0,0.1)',
                  transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                  '&:hover': {
                    transform: 'scale(1.05)',
                    boxShadow: '0 8px 16px rgba(0, 188, 212, 0.3)',
                    cursor: 'pointer'
                  }
                }
              }}>
                <img 
                  src="/image/aboutme.png" 
                  alt="About Me" 
                />
              </Box>
              <Typography variant="h5" gutterBottom sx={{ fontWeight: 600, mb: 2, textAlign: 'center' }}>
                Get to know me!
              </Typography>
              <Typography paragraph sx={{ mb: 2, color: 'text.secondary' }}>
                I'm a passionate Full Stack Developer with expertise in building exceptional digital experiences. 
                With a strong foundation in both front-end and back-end technologies, I create seamless, 
                responsive, and user-friendly applications.
              </Typography>
              <Typography paragraph sx={{ mb: 4, color: 'text.secondary' }}>
                My journey in Backend Developer started 3 years ago, and since then, I've had the privilege 
                of working with various companies and clients, helping them bring their ideas to life 
                through clean, efficient, and scalable code.
              </Typography>
              
              <Grid container spacing={4} sx={{ mt: 4, justifyContent: 'center' }}>
                {experiences.map((item, index) => (
                  <Grid item xs={12} sm={6} md={4} key={index} sx={{ display: 'flex', justifyContent: 'center' }}>
                    <Paper 
                      elevation={0} 
                      sx={{ 
                        p: 3, 
                        width: '100%',
                        maxWidth: '300px',
                        height: '100%',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        textAlign: 'center',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        transition: 'transform 0.3s, box-shadow 0.3s',
                        '&:hover': {
                          transform: 'translateY(-5px)',
                          boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
                        },
                      }}
                    >
                      <Box sx={{ mb: 2, display: 'flex', justifyContent: 'center', width: '100%' }}>{item.icon}</Box>
                      <Typography variant="h6" sx={{ fontWeight: 600, mb: 1, width: '100%' }}>
                        {item.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {item.description}
                      </Typography>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            </Grid>
            
            <Grid item xs={12} md={6}>
              {/* This space is intentionally left empty */}
            </Grid>
          </Grid>
        </motion.div>
      </Container>
    </Box>
  );
};

export default About;
